import { assignJob, getFreePopulation } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireHunterAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.huntingHut.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = settlement.buildings.huntingHut.qty;
    if (settlement.jobs.hunters >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'hunters')) return false;
    settlement.production.hunt.progress.push(0);
    return true;
};
